import { useEffect } from "react";
import { useShellStore } from "@/features/shell/stores/shellStore";
import { useIsLoggedIn } from "./useIsLoggedIn";
import { PROFILE_COMPLETION_MODAL } from "../components/ProfileCompletionModal";
import {
  useCustomerLicence,
  useProfile,
} from "@/hooks/firestore/user/useProfile";
import { CustomerLicenceOptions } from "../models/session";

export const useIncompleteProfileCheck = () => {
  const isLoggedIn = useIsLoggedIn();
  const { profile, isLoading } = useProfile();
  const licence = useCustomerLicence();
  const setModal = useShellStore((state) => state.setModal);

  const isMissingPhone = !isLoading && !!profile && !profile?.phone;

  const shouldShow =
    isLoggedIn &&
    Boolean(isMissingPhone) &&
    licence === CustomerLicenceOptions.NTRWC;

  useEffect(() => {
    if (!shouldShow) return;

    setModal(PROFILE_COMPLETION_MODAL);
  }, [shouldShow, setModal]);
};
